import type { LucideIcon } from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

interface ProjectOverviewCardProps {
  to: string;
  title: string;
  description: string;
  icon: LucideIcon;
  tone: "red" | "blue" | "green" | "lavender";
  meta: string;
}

export function ProjectOverviewCard({ to, title, description, icon: Icon, tone, meta }: ProjectOverviewCardProps) {
  return (
    <Link to={to} className={`overview-card overview-card--${tone}`}>
      <div className="overview-card__top">
        <span className="overview-card__icon"><Icon size={24} strokeWidth={1.7} aria-hidden="true" /></span>
        <ArrowUpRight size={20} aria-hidden="true" />
      </div>
      <div>
        <span className="overview-card__meta">{meta}</span>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
    </Link>
  );
}
